import type { DropdownItemProps } from '@space-core/components/dropdown/types'
import type { ThemeMode } from '@space-core/styles/themes/enum'
import type { ApplicationLanguageType } from '@space-shell/common/components/customLanguage/constants'
import DropdownPrivate from '@space-shell/common/components/dropdown'
import GlobalSearch from '@space-shell/modules/globalSearch'
import { MembershipChatConsumer } from '@space-shell/modules/membershipChatConsumer'
import NotificationCenter from '@space-shell/modules/notificationCenter'

import HeaderOptions from './headerOptions'

type AuthenticatedHeaderProps = {
  privateItems: DropdownItemProps[]
  theme: ThemeMode
  switchTheme: () => void
  userName: string
  applicationLanguage: string
  handleLanguageChange: (lang: ApplicationLanguageType) => void
  isGlobalSearchEnabled: boolean
  isMembershipChatEnabled: boolean
  isNotificationsEnabled: boolean
  isGamificationEnabled: boolean
}

export function AuthenticatedHeader({
  privateItems,
  theme,
  switchTheme,
  userName,
  applicationLanguage,
  handleLanguageChange,
  isMembershipChatEnabled,
  isGamificationEnabled,
  isGlobalSearchEnabled,
  isNotificationsEnabled
}: AuthenticatedHeaderProps) {
  return (
    <>
      {isGlobalSearchEnabled && <GlobalSearch />}
      {isMembershipChatEnabled && <MembershipChatConsumer slot='actions-end' />}

      {isNotificationsEnabled && <NotificationCenter />}

      <DropdownPrivate userName={userName} dropdownItems={privateItems} theme={theme} isLogged>
        <HeaderOptions
          isAuthenticated
          isGamificationEnabled={isGamificationEnabled}
          switchTheme={switchTheme}
          applicationLanguage={applicationLanguage}
          handleLanguageChange={handleLanguageChange}
          theme={theme}
        />
      </DropdownPrivate>
    </>
  )
}
